import React from 'react';
import { MainLayout } from '@components';
import RadiologistComponents from './Radiologist';

export default function RadiologistPage(props) {
  return (
    <MainLayout footer="main" children={<RadiologistComponents {...props} />} />
  );
}
